export const outboxAreaMenuName = 'Udbakke';
export const outboxAreaPathName = 'outbox';
